import React, { Component } from 'react';
import { connect } from 'react-redux';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import {
  setQuickSearchResultFlg,
  searchCompanyHierarchyList,
  setHierarchyKbn,
  searchCompanyList,
} from '../../actions/CompanyAction';
import {
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import {
  HIERARCHY_KBN,
  DISP_COUNT_LIMIT,
  COMPANY_RESULT_PAGING,
} from '../../../common/const';

import styles from './CompanyResultListComponent.module.css';

class CompanyResultListComponent extends Component {
  /**
   * 企業検索結果一覧POPUPから、選択されたレコードの値を元に、一時保存領域に値を保持する。
   */
  selectCompanyInfo = async (company) => {
    const {
      searchCompanyHierarchyListAct,
      setSystemLodingFLgAct,
      setQuickSearchResultFlgAct,
      setHierarchyKbnAct,
    } = this.props;

    setSystemLodingFLgAct(true);

    // 検索処理を実行し、一時保存領域で保持する
    const ret = await searchCompanyHierarchyListAct(company.kigyo_code);
    // 検索結果が存在する場合
    if (ret) {
      // 階層情報区分値設定
      setHierarchyKbnAct(HIERARCHY_KBN.FUND);
    }
    setQuickSearchResultFlgAct(false);
    setSystemLodingFLgAct(false);
  };

  /**
   * 検索条件詳細POPUPを閉じる
   */
  closePopup = () => {
    const { setQuickSearchResultFlgAct } = this.props;
    setQuickSearchResultFlgAct(false);
  };

  /**
  * ページ選択
  */
  changePage = async (page) => {
    const {
      searchCompanyListAct,
      setSystemLodingFLgAct,
      searchCondition,
    } = this.props;

    setSystemLodingFLgAct(true);
    // ページ番号を指定して検索処理実行
    await searchCompanyListAct(searchCondition, page);
    setSystemLodingFLgAct(false);
  }

  render() {
    const {
      companyResultList,
      quickSearchResultFlg,
      nowpage,
    } = this.props;
    const companyList = companyResultList.company_list;

    // ページングの表示処理 ここから
    let pagingArea = null;

    // 全体件数
    let totalCount = null;

    // 全体件数が最大取得件数以上の場合、全体件数を最大取得件数に設定
    if (companyResultList
      && companyResultList.all_count) {
      totalCount = companyResultList.all_count < DISP_COUNT_LIMIT.COMPANY
        ? companyResultList.all_count : DISP_COUNT_LIMIT.COMPANY;
    }

    // 全体件数が最大表示件数以下の場合、ページング表示処理を実施
    if (companyResultList
      && totalCount) {
      const maxPageCount = totalCount === 0
        ? 1
        : Math.ceil(totalCount / COMPANY_RESULT_PAGING.PAGE_RECORD_COUNT);

      // 最後のページ数を算出
      const endPageCount = nowpage + COMPANY_RESULT_PAGING.AFTER_PAGE_COUNT < maxPageCount
        ? nowpage + COMPANY_RESULT_PAGING.AFTER_PAGE_COUNT
        : maxPageCount;
      // 最初のページ数を算出
      const startPageCount = nowpage - COMPANY_RESULT_PAGING.BEFORE_PAGE_COUNT > 1
        ? nowpage - COMPANY_RESULT_PAGING.BEFORE_PAGE_COUNT
        : 1;

      const pageList = [];
      if (startPageCount > 1) {
        pageList.push(<span key={1} className="space">...</span>);
      }
      for (let count = startPageCount; count <= endPageCount; count += 1) {
        pageList.push(
          <span
            key={count}
            className={[
              endPageCount === count ? 'last-page-link' : 'page-link',
              nowpage === count ? 'nowpage' : '',
            ].join(' ')}
            onClick={nowpage === count
              ? null
              : this.changePage.bind(this, count)}
          >
            {count}
          </span>,
        );
      }
      if (endPageCount < maxPageCount) {
        pageList.push(<span key={maxPageCount} className="space">...</span>);
      }
      pagingArea = (
        <Pagination
          variant="outlined"
          count={maxPageCount}
          onChange={(e, page) => this.changePage(page)}
          page={nowpage}
          className={`${styles.displayInline}`}
          renderItem={(item) => (
            <PaginationItem
              {...item}
              disabled={
                item.page === nowpage
                || (item.type === 'next' && nowpage === maxPageCount)
                || (item.type === 'previous' && nowpage === 1)
              }
              className={`${item.page === nowpage ? styles.customPaginationItem : ''}`}
            />
          )}
        />
      );
    }

    // ページングの表示処理 ここまで

    // 表示件数作成
    const dispCountStart = (nowpage - 1) * COMPANY_RESULT_PAGING.PAGE_RECORD_COUNT + 1;
    const dispCountEnd = (companyResultList
      && companyResultList.result_count
      && totalCount)
      ? (nowpage - 1) * COMPANY_RESULT_PAGING.PAGE_RECORD_COUNT
      + Number(companyResultList.result_count)
      : null;
    const dispResultCount = dispCountEnd ? `${dispCountStart}-${dispCountEnd}` : 0;

    // 全体件数
    const allCount = (companyResultList && totalCount)
      ? Number(totalCount).toLocaleString()
      : 0;

    // 最大表示件数
    const dispCountLimit = Number(DISP_COUNT_LIMIT.COMPANY).toLocaleString();

    return (
      quickSearchResultFlg && (
      <Box className={`${styles.searchCond}`}>
        <Box className={`${styles.contents}`}>
          <Box className={`${styles.header}`}>
            <Box className={`${styles.title}`}>
              国内系列企業検索
            </Box>
            <Box className={`${styles.close}`} onClick={() => this.closePopup.bind(this)}>
              <Button
                className={`${styles.closeButton} tooltip`}
                variant="contained"
                startIcon={<Close className={`${styles.closeIcon}`} />}
                onClick={() => this.closePopup(this)}
              >
                <Box className={`${styles.description} description`}>閉じる</Box>
              </Button>
            </Box>
          </Box>
          <Box tabIndex="-1" className={`${styles.infofield}`}>
            <Box>
              <Box className={`${styles.marginbottom}`}>
                <Box component="span" className={`${styles.searchResult}`}>{dispResultCount}</Box>
                <span>{` / ${allCount}件`}</span>
                <span className={`${styles.subtitleColor}`}>
                  &emsp;
                  {`※最大${dispCountLimit}件までしか表示されません`}
                </span>
              </Box>
              {pagingArea}
            </Box>
          </Box>

          <Box tabIndex="0" className={`${styles.searchResultarea}`}>
            <Box className={`${styles.tableHraderArea}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableHead className={`${styles.tableHead}`}>
                  <TableRow>
                    <TableCell className={`${styles.tableHeader} ${styles.tableCell} ${styles.name}`}>商号漢字</TableCell>
                    <TableCell className={`${styles.tableHeader} ${styles.tableCell} ${styles.address}`}>所在地</TableCell>
                    <TableCell className={`${styles.tableHeader} ${styles.tableCell} ${styles.tel}`}>電話番号</TableCell>
                    <TableCell className={`${styles.tableHeader} ${styles.tableCell} ${styles.representative}`}>代表者名</TableCell>
                    <TableCell className={`${styles.tableHeader} ${styles.tableCell} ${styles.office}`}>事業所数</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </Box>
            <Box tabIndex="-1" className={`${styles.scroll}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableBody>
                  {companyList
                    && companyList.map((company, i) => (
                      <TableRow key={`${company}_${i}`} onClick={() => this.selectCompanyInfo(company)}>
                        <TableCell className={`${styles.tableCell} ${styles.name}`}>{company.trade_name}</TableCell>
                        <TableCell className={`${styles.tableCell} ${styles.address}`}>{company.address}</TableCell>
                        <TableCell className={`${styles.tableCell} ${styles.tel}`}>{company.phone_number}</TableCell>
                        <TableCell className={`${styles.tableCell} ${styles.representative}`}>{company.representative_name}</TableCell>
                        <TableCell className={`${styles.tableCell} ${styles.office}`}>{!Number.isNaN(Number(company.office_count)) ? Number(company.office_count).toLocaleString() : ''}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Box>
          </Box>
        </Box>
      </Box>
      ));
  }
}

export default connect(
  (state) => ({
    // 検索結果一覧の表示フラグ
    quickSearchResultFlg: state.company.quickSearchResultFlg,
    // 検索結果一覧オブジェクト
    companyResultList: state.company.companyResultList,
    nowpage: state.company.nowpage,
    searchCondition: state.company.searchCondition,
  }),
  (dispatch) => ({
    setQuickSearchResultFlgAct: (bool) => dispatch(setQuickSearchResultFlg(bool)),
    searchCompanyHierarchyListAct: (obj) => dispatch(searchCompanyHierarchyList(obj)),
    setHierarchyKbnAct: (str) => dispatch(setHierarchyKbn(str)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    searchCompanyListAct: (condition, page) => dispatch(searchCompanyList(condition, page)),
  }),

)(CompanyResultListComponent);
